<!--
 * @Author: wsx
 * @Date: 2022-02-14 16:55:18
 * @LastEditTime: 2022-02-25 15:13:48
 * @Description: 首页
 * @FilePath: \hz-digital-twin\src\views\Home\index.vue
-->
<template>
  <div class="home">
    <left-frame></left-frame>
    <right-frame></right-frame>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, watch } from "vue";

// import { lang, getLocale } from "@/locales";
// import { useI18n } from 'vue-i18n'
import { useStore } from "vuex";

import RightFrame from "./RightFrame.vue";
import LeftFrame from "./LeftFrame.vue";
import layout from "./layout/index.vue";
export default defineComponent({
  name: "Home",
  components: { RightFrame, LeftFrame, layout },
  setup() {
    const state = reactive({
      name: "Layout",
      value1: "",
      currentPage1: 5,
      small: false,
      // radio1: getLocale(),
    });
    // const { t } = useI18n();
    const store = useStore();
    const refData = toRefs(state);
    const setLocale = (v) => store.commit("setLocale", v);
    watch(
      () => state.radio1,
      (v) => {
        setLocale(v);
      }
    );
    return {
      ...refData,
      // t,
    };
  },
});
</script>
<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  align-content: center;
}
</style>
